import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Bar, ComposedChart, LabelList, Legend, Tooltip, ResponsiveContainer, XAxis, YAxis } from "recharts";
import { IDemandPayload, IRoot } from "../../services/interface/IDemand";
import { formatter } from "../../utils/formatter";
import { useGetForecastOverviewBarchat } from "../../services/redux/hooks/useDemand";
import moment from "moment";

const CustomTooltip = (props: any) => {
  const { active, payload } = props;
  if (active && payload && payload.length) {
      return (
          <div className="bg-[#fff] border-[1px] border-[#BEBEBE] p-2 rounded rs-bg">
              <div className="flex flex-col gap-2">
                  {payload?.map(($: any) => (
                      <div className="flex flex-col" key={$?.name}>
                          <p className="text-black text-fs14">
                            {$.name}
                          </p>
                          <p style={{ color: $.color }} className="text-black text-fs20 font-bold">
                            {formatter($.value)}
                          </p>
                      </div>
                  ))}
              </div>
          </div>
      );
  }
  return null;
};

const Graph = (props:any)=>{
    const [barGraphData, setBarGraphData] = useState<any>();
    const {mutate, data: barData} = useGetForecastOverviewBarchat();
    const selectedDbFilter = useSelector((state:IRoot)=>state.dbfilter.selectedDbFilter);
    const mapdc = useSelector((state:IRoot)=>state.dbfilter.mapdc);
    const mapstore = useSelector((state:IRoot)=>state.dbfilter.mapstore);
    const applyFilter = useSelector((state:IRoot)=>state.dbfilter.applyFilter);
    const selectedFlagMarker = useSelector((state:IRoot)=>state.dbfilter.selectedFlagMarker);

    const prepareData=(data:any[])=>{
      let finalData:any=[];
      data?.map((each)=>{
        let obj = {
          "Actual": each?.TotalPounds,
          "Forecast": each?.TotalForecast,
          "forecastDate": moment(each?.forecast_date?.slice(0, 10)).format("MM-DD-YYYY")
        }
        finalData.push(obj);
      });
      setBarGraphData(finalData);
    }

    // To filter based on dropdown
    useEffect(() => {
        if (applyFilter === "" || applyFilter === "applied" || ["drilldown", "drillup"].includes(applyFilter)) {
            let mergedFilter: IDemandPayload = {...selectedDbFilter};
            if (applyFilter === "drilldown" && selectedFlagMarker?.location?.length > 0) {
                mergedFilter.dc = selectedDbFilter.dc && selectedDbFilter.dc.length > 0 ?
                    selectedDbFilter.dc : mapdc;
                mergedFilter.storeNumber = selectedDbFilter.storeNumber && selectedDbFilter.storeNumber.length > 0 ?
                    selectedDbFilter.storeNumber : mapstore;
                mutate(mergedFilter);

            } else if (applyFilter === "drillup") {

                mergedFilter.dc = selectedDbFilter.dc && selectedDbFilter.dc.length > 0 ?
                    selectedDbFilter.dc : mapdc;
                mergedFilter.storeNumber = selectedDbFilter.storeNumber && selectedDbFilter.storeNumber.length > 0 ?
                    selectedDbFilter.storeNumber : mapstore;
                mutate(mergedFilter);

            } else if (applyFilter === "" || applyFilter === "applied") {
                if (selectedFlagMarker?.location?.length <= 0) {
                    mergedFilter = {
                        ...selectedDbFilter
                    };
                    mergedFilter.dc = selectedDbFilter.dc && selectedDbFilter.dc.length > 0 ?
                        selectedDbFilter.dc : mapdc;
                    mergedFilter.storeNumber = selectedDbFilter.storeNumber && selectedDbFilter.storeNumber.length > 0 ?
                        selectedDbFilter.storeNumber : mapstore;
                } else {
                    mergedFilter.dc = selectedDbFilter.dc && selectedDbFilter.dc.length > 0 ?
                        selectedDbFilter.dc : [selectedFlagMarker.branchId];
                    mergedFilter.storeNumber = selectedDbFilter.storeNumber && selectedDbFilter.storeNumber.length > 0 ?
                        selectedDbFilter.storeNumber : mapstore;
                }
                mutate(mergedFilter);
                console.log("mergedFilter", mergedFilter);
                
            }
        }
    }, [applyFilter, selectedFlagMarker]);
  
    useEffect(()=>{
      if(barData){
        prepareData(barData?.data);
      }
    },[barData]);

    return <div className="w-[99%] h-full bg-[#FFF] shadow rounded px-[1%] py-[10px] border-[1px] border-[#BEBEBE] flex flex-col">
        <div className="flex justify-between items-center mb-2">
            <span className="text-mainGreen font-semibold chart-title self-start">
                {props.title}
            </span>
        </div>
        <div className="graph-container flex-grow h-full">
            <ResponsiveContainer width={"100%"} height={"100%"}>
                <ComposedChart data={barGraphData} margin={{ top: 20, right: 20, bottom: 40, left: 8 }}>
                    <XAxis angle={-45} interval={0} textAnchor="end" fontSize={"0.6vw"} dataKey="forecastDate" />
                    <YAxis interval="equidistantPreserveStart" fontSize={"0.8vw"} tickFormatter={formatter} />
                    <Tooltip content={<CustomTooltip/>} />
                    <Legend 
                        align="left"
                        verticalAlign="top"
                        iconSize={8}
                        wrapperStyle={{ left: 0, top: -5, marginBottom: "10px" }} />
                        {/* fill="#86BC25" */}
                    <Bar dataKey="Actual" fill="#012169" maxBarSize={30}>
                    </Bar>
                    <Bar dataKey="Forecast" fill="#86BC25" maxBarSize={30}>
                    </Bar>
                </ComposedChart>
            </ResponsiveContainer>
        </div>
    </div>
}

export default Graph;